import React from 'react';
import { Inbox } from 'lucide-react';

const TONE_CLASSES = {
  light: { box: 'bg-slate-100 text-slate-400', title: 'text-slate-700', desc: 'text-slate-500' },
  dark: { box: 'bg-slate-800 text-slate-500', title: 'text-slate-200', desc: 'text-slate-500' },
};

const EmptyState = ({ icon: Icon = Inbox, title, description, action, tone = 'light', className = '' }) => {
  const t = TONE_CLASSES[tone];
  return (
    <div className={['flex flex-col items-center justify-center text-center py-16 px-4', className].join(' ')}>
      <div className={['w-16 h-16 rounded-2xl flex items-center justify-center mb-4', t.box].join(' ')}>
        <Icon className="w-7 h-7" />
      </div>
      {title && <p className={['font-semibold', t.title].join(' ')}>{title}</p>}
      {description && <p className={['text-sm max-w-sm mt-1', t.desc].join(' ')}>{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
